import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SESSION_FEATURE_KEY, SessionState } from './session.reducer';

export const selectSessionState = createFeatureSelector<SessionState>(SESSION_FEATURE_KEY);

export const selectSessions = createSelector(selectSessionState, (state) => state?.data ?? null);
export const selectSessionDetail = createSelector(selectSessionState, (state) => state?.detail ?? null);
export const selectSessionsTotal = createSelector(selectSessionState, (state) => state?.total ?? 0);
export const selectSessionsQuery = createSelector(selectSessionState, (state) => state?.query ?? null);
export const selectSessionsLoading = createSelector(selectSessionState, (state) => state?.loading ?? false);
export const selectSessionsError = createSelector(selectSessionState, (state) => state?.error ?? null);
